import { RSAA } from 'redux-api-middleware';
import { getGeolocation } from '../../utils/helper/page-behavior-helper';
import { getCoordinateAxleFromStorage, getRequestAdditionalHeader } from './util-actions';
import reduxStore from '../store';

export const AUTH_LOGIN = '/auth/login';
export const AUTH_LOGIN_SUCCESS = '/auth/login/success';
export const AUTH_LOGIN_FAILURE = '/auth/login/failure';

export const LOGOUT = '/auth/logout';
export const LOGOUT_SUCCESS = '/auth/logout/success';
export const LOGOUT_FAILURE = '/auth/logout/failure';

export const REQUEST_PASSWORD = '/auth/password/request';
export const REQUEST_PASSWORD_SUCCESS = '/auth/password/request/success';
export const REQUEST_PASSWORD_FAILURE = '/auth/password/request/failure';

export const CHANGE_PASSWORD = '/auth/password/change';
export const CHANGE_PASSWORD_SUCCESS = '/auth/password/change/success';
export const CHANGE_PASSWORD_FAILURE = '/auth/password/change/failure';

export const GET_TEMP_TOKEN = '/auth/temp-token';
export const GET_TEMP_TOKEN_SUCCESS = '/auth/temp-token/success';
export const GET_TEMP_TOKEN_FAILURE = '/auth/temp-token/failure';

export const GET_LOGGED = '/auth/logged';
export const GET_LOGGED_SUCCESS = '/auth/logged/success';
export const GET_LOGGED_FAILURE = '/auth/logged/failure';

export const RESET_AUTH = '/auth/reset';


export function login(username, password, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/auth/login`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({ username, password }),
      types: [AUTH_LOGIN, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAILURE],
    },
  };
}

export function refreshToken({ refreshToken, accessToken }, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/auth/token/refresh`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({ refreshToken, accessToken }),
      types: [AUTH_LOGIN, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAILURE],
    },
  };
}

export function getTempToken(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/auth/temp-token`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_TEMP_TOKEN, GET_TEMP_TOKEN_SUCCESS, GET_TEMP_TOKEN_FAILURE],
    },
  };
}

export function logged() {
  getGeolocation();
  const device = reduxStore?.getState()?.customer?.device;
  return {
    [RSAA]: {
      endpoint: `/api/auth/logged`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_LOGGED, GET_LOGGED_SUCCESS, GET_LOGGED_FAILURE],
    },
  };
}

/**
 * Logs the user out.
 */
export function logout(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/auth/logout`,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAILURE],
    },
  };
}

/**
 * Requests password change.
 */
export function requestPasswordChange(username, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/auth/password?username=${username}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [REQUEST_PASSWORD, REQUEST_PASSWORD_SUCCESS, REQUEST_PASSWORD_FAILURE],
    },
  };
}

/**
 * Changes password.
 */
export function changePassword(username, validationCode, password, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/auth/password?username=${username}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        validationCode,
        newPassword: password,
      }),
      types: [CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE],
    },
  };
}
